var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notification-config-modal" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.$t("system.notification_config"),
            "close-on-click-modal": false,
            width: "720px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogLoading,
                  expression: "dialogLoading",
                },
              ],
              staticClass: "modal-body",
            },
            [
              _c(
                "div",
                { staticClass: "notification-list" },
                _vm._l(_vm.notificationTypes, function (type) {
                  return _c(
                    "div",
                    { key: type.value, staticClass: "notification-item" },
                    [
                      _c("div", { staticClass: "item-main" }, [
                        _c("div", { staticClass: "item-left" }, [
                          _c("div", { staticClass: "item-title" }, [
                            _vm._v(_vm._s(type.label)),
                          ]),
                          _c("div", { staticClass: "item-desc" }, [
                            _vm._v(_vm._s(type.description)),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "item-right" },
                          [
                            _c("span", { staticClass: "receive-label" }, [
                              _vm._v(
                                _vm._s(_vm.$t("system.receive_notification"))
                              ),
                            ]),
                            _c("el-switch", {
                              attrs: { value: _vm.isTypeSelected(type.value) },
                              on: {
                                change: function ($event) {
                                  return _vm.toggleType(type.value, $event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      type.value === 5 && _vm.userInfo.account_type === 1
                        ? _c("div", { staticClass: "item-extra" }, [
                            _c(
                              "div",
                              { staticClass: "warn-amount-section" },
                              _vm._l(
                                _vm.warnAmountList,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      class: [
                                        "warn-amount-row",
                                        {
                                          "has-error":
                                            _vm.duplicateErrors[index],
                                        },
                                      ],
                                    },
                                    [
                                      index === 0
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "warn-amount-label",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("system.warn_amount")
                                                ) + ":"
                                              ),
                                            ]
                                          )
                                        : _c("span", {
                                            staticClass:
                                              "warn-amount-label-placeholder",
                                          }),
                                      _c(
                                        "div",
                                        { staticClass: "warn-amount-field" },
                                        [
                                          _c("el-input", {
                                            staticClass: "warn-amount-input",
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "system.warn_amount_placeholder"
                                              ),
                                              size: "small",
                                              disabled:
                                                !_vm.isEditingWarnAmount,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.handleWarnAmountInput(
                                                  $event,
                                                  item
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.handleWarnAmountBlur(
                                                  item,
                                                  index
                                                )
                                              },
                                            },
                                            model: {
                                              value: item.value,
                                              callback: function ($$v) {
                                                _vm.$set(item, "value", $$v)
                                              },
                                              expression: "item.value",
                                            },
                                          }),
                                          _vm.isEditingWarnAmount
                                            ? _c("i", {
                                                staticClass:
                                                  "el-icon-circle-close delete-icon",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeWarnAmountRow(
                                                      index
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                          _vm.duplicateErrors[index]
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "warn-amount-error",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.duplicateErrors[index]
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.rangeErrors[index]
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "warn-amount-error",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.rangeErrors[index]
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      index === _vm.warnAmountList.length - 1
                                        ? [
                                            !_vm.isEditingWarnAmount
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "primary",
                                                      size: "mini",
                                                    },
                                                    on: {
                                                      click: _vm.editWarnAmount,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "components.edit"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : [
                                                  _vm.warnAmountList.length < 3
                                                    ? _c(
                                                        "el-button",
                                                        {
                                                          staticClass:
                                                            "add-warn-btn",
                                                          on: {
                                                            click:
                                                              _vm.addWarnAmountRow,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "system.add_warn_amount"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "primary",
                                                        size: "small",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.saveWarnAmount(
                                                            index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("system.save")
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: { size: "small" },
                                                      on: {
                                                        click:
                                                          _vm.cancelWarnAmount,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "components.cancel"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                }
                              ),
                              0
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "test-link",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sendTestNotification($event)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("system.send_test_notification")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }